<div class="row">

  <button type="button" id="btnPopupDT" (click)="DownloadFile()" style="display:none">POP-UP</button>

  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="col-sm-12" id="divMainFilter">
          <div class="row" style="display:none">
            <div class="col-sm-8">
              <label>Journals</label>
              <select id="lstJournals" class="form-control" multiple onchange="$('#btnGetVolumeIssues').trigger('click');">
                <option *ngFor="let item of journalList" value={{item.ID}}>
                  {{item.Acronym}}
                </option>
              </select>
            </div>
            <div class="col-sm-2">
              <label>Volume</label>
              <select id="lstVolume" class="form-control">
                <option selected value="0">All</option>
                <option *ngFor="let item of volumeList" value={{item.ID}}>
                  {{item.Volume}}
                </option>
              </select>
            </div>
            <div class="col-sm-2">
              <label>Issue</label>
              <select id="lstIssue" class="form-control">
                <option selected value="0">All</option>
                <option *ngFor="let item of issueList" value={{item.ID}}>
                  {{item.Issue}}
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <label>Report Type</label>
              <select id="ddlReportType" class="form-control">
                <option selected value="0">Select</option>
                <option *ngFor="let item of reportTypeList" value={{item.MenuName}}>
                  {{item.MenuName}}
                </option>
              </select>
            </div>
            <div class="col-sm-2">
              <label>From</label>
              <input type="date" name="FromDate" class="form-control float-right" id="Txt_FromDate" autocomplete="off">
            </div>
            <div class="col-sm-2">
              <label>To</label>
              <input type="date" name="ToDate" class="form-control float-right" id="Txt_ToDate" autocomplete="off">
            </div>
            <div class="col-sm-2">
              <br />
              <label>Skip Date Filter</label><br />
              <input type="checkbox" id="chkSkipDate" />
            </div>
            <div class="col-sm-2">
              <button type="button" class="btn btn-outline-info waves-effect waves-light clsMargin" id="btnLoadList" title="Get" (click)="getFiltered()">Search</button>
              <button type="button" class="btn btn-outline-danger waves-effect waves-light clsMargin" title="Clear" (click)="resetFilter()" style="margin-left:10px">Reset</button>
            </div>
          </div>
        </div>

        <div class="col" style="padding-top:10px">
          <button type="button" id="btnGetVolumeIssues" (click)="getVolumeIssue()" style="display:none">GetVolumeIssue</button>

          <table #dataTableReport class="display" style="width:100%;"></table>

          <button type="button" id="btnFilterPanel" (click)="ShowFilterPanel()" style="display:none">Filter</button>

          <div class="control-sidebar control-sidebar panelBox" style="display: none;" id="divFilterPanel">
            <h5>Data Filter<i class="fas fa-times" (click)="HideFilterPanel()" title="Close"></i></h5>
            <hr />
            <div class="divFilter" id="divFilter">
              <br />
              <div class="row">

                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="ddlFilterDateType">Date Type</label>
                    <select id="ddlFilterDateType" class="form-control">
                      <option value='DownloadDate'>Download</option>
                      <option value='CompletionDate'>Completion</option>
                      <option value='SubmissionDate'>Submission</option>
                      <option value='FeedbackDate'>Feedback</option>
                      <option value='AssignedDate'>Assigned</option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-6" name="FromDate">
                  <div class="form-group">
                    <label for="txtFromDtList">From Date</label>
                    <input type="date" class="form-control" id="txtFromDtList">
                  </div>
                </div>

                <div class="col-sm-6" name="ToDate">
                  <div class="form-group">
                    <label for="txtToDtList">To Date</label>
                    <input type="date" class="form-control" id="txtToDtList">
                  </div>
                </div>

                <div class="col-sm-12 divHide">
                  <div class="form-group">
                    <label for="ddlFilterPulisher">Publisher</label>
                    <select id="ddlFilterPulisher" class="form-control">

                      <option *ngFor="let item of PublisherList" value={{item.ID}}>
                        {{item.PublisherCode}}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="ddlFilterTeamLead">Team Lead</label>
                    <select id="ddlFilterTeamLead" class="form-control" (change)="GetFilterUserList()">
                      <option value="0">All</option>
                      <option *ngFor="let item of UserLeadList" value={{item.UserID}}>
                        {{item.LoginName}}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="ddlFilterAllocatedUser">PRA</label>
                    <select id="ddlFilterAllocatedUser" class="form-control" multiple>
                      <!--<option value="0">All</option>
        <option value="-1">UnAllocate</option>-->
                      <option *ngFor="let item of FilterUserList" value={{item.UserID}}>
                        {{item.LoginName}}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="ddlFilterJournal">TLA</label>
                    <select id="ddlFilterJournal" class="form-control" multiple>
                      <!--<option value='All'>All</option>-->
                      <option *ngFor="let item of JournalList" value={{item.Journalcode}}>
                        {{item.Journalcode}}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Task Name</label>
                    <select id="ddlFilterTaskName" class="form-control" multiple>
                      <option value='Admin Checklist'>Admin Checklist</option>
                      <option value='Forms In'>Forms In</option>
                      <option value='Production Checklist'>Production Checklist</option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Task Status</label>
                    <select id="ddlFilterStatus" class="form-control" multiple>
                      <option value="Pending">Current</option>
                      <option value="Saved">Saved</option>
                      <option value="Problem">Problem</option>
                      <option value="Future">Future</option>
                      <option value="Not Applicable">Not Applicable</option>
                      <option value="Late">Late</option>
                      <option value="Completed">Completed</option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Feedback Type</label>
                    <select id="ddlFilterFeedbackType" class="form-control">
                      <option value="All" selected>All</option>
                      <option value="Internal">Internal</option>
                      <option value="External">External</option>
                    </select>
                  </div>
                </div>

              </div>
              <br />
              <div class="col-sm-12">
                <div class="col clsCenter">
                  <button type="button" id="btnLoad" class="btn btn-info waves-effect waves-light"
                          title="Get" (click)="getFiltered();">
                    Search
                  </button>
                  &nbsp;
                  <button type="button" class="btn btn-danger waves-effect waves-light" title="Reset"
                          (click)="ResetPopupFilter()">
                    Reset
                  </button>
                
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>


    </div>
  </div>
</div>
